import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZnRequestformComponent } from './zn-requestform.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomRadioButtonModule } from 'src/app/shared/components/custom-radio-button/custom-radio-button.module';
import { MaterialModule } from 'src/app/shared/material/material.module';

@NgModule({
  declarations: [ZnRequestformComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    CustomInputModule,
    CustomRadioButtonModule,
    CustomDatePickerModule,
    CustomDropdownModule,
  ],
  exports: [ZnRequestformComponent],
})
export class ZnRequestformModule {}
